import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import { genderDefinition, genderHandler } from './gender';

export const multiGenderDefinition: FilterDefinition<MultiFilter<ListFilter>> =
  {
    id: FilterId.MULTI_GENDER,
    name: 'Gender',
    type: FilterType.MULTI,
    wrappedFilterId: FilterId.GENDER,
    instances: [],
    isVisible: true,
  };

export const multiGenderHandler: FilterHandler<MultiFilter<ListFilter>> = {
  isActive(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.some((instance) =>
      genderHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      genderHandler.getEffectiveFilter(instance, genderDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
